import { render, staticRenderFns } from "./MobileClinetDashboard.vue?vue&type=template&id=53e2c561&scoped=true&"
import script from "./MobileClinetDashboard.vue?vue&type=script&lang=js&"
export * from "./MobileClinetDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MobileClinetDashboard.vue?vue&type=style&index=0&id=53e2c561&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e2c561",
  null
  
)

export default component.exports